module.exports = __webpack_public_path__ + "static/media/tunewise_logo.d8476114.png";